import { CheckCircle2 } from 'lucide-react';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import type { ChecklistData } from '../../../types/blog';

interface ChecklistProps {
  data: ChecklistData;
}

const Checklist: React.FC<ChecklistProps> = ({ data }) => {
  const items = data.items ?? [];

  return (
    <ul className="space-y-3 list-none m-0 p-0">
      {items.map((item, i) => (
        <li key={i} className="flex items-start gap-3">
          <CheckCircle2
            className="w-5 h-5 shrink-0 mt-0.5"
            style={{ color: 'var(--vscode-primary)' }}
            strokeWidth={2}
          />
          <div className="vscode-text-primary leading-relaxed prose prose-sm max-w-none dark:prose-invert">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{item}</ReactMarkdown>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default Checklist;
